import gql from "graphql-tag";

export const GET_CAR = gql`
  query car($id: ID!) {
    car(id: $id) {
      id
      name
      norwegianListPriceAsNew
      registrationNumber
    }
  },
`;
